<script>
    import { t } from 'totalinvoice-frontend-core'
    import { DataTable }  from "totalinvoice-frontend-core"

    export let customerList
    export let searchable
    export let sortable

    const detailsLinkFormatter = (id, col, value) => (`<a href="./${id}">${$t("Details")}</a>`)

    const columns = [{
        label: 'ID', // column name
        field: 'id', // field name from row
        visible: true,
        numeric: false, // affects sorting
        formatter: null
    }, {
        label: 'Civility / Type',
        field: 'title',
        visible: true,
        numeric: false,
        formatter: null
    }, {
        label: 'First name',
        field: 'first_name',
        visible: true,
        numeric: false,
        formatter: null
    }, {
        label: 'Last name',
        field: 'last_name',
        visible: true,
        numeric: false,
        formatter: null
    }, {
        label: 'Details',
        field: 'id',
        visible: true,
        numeric: false,
        formatter: detailsLinkFormatter
    }]
</script>

{#if customerList && customerList.length > 0}
    <DataTable rowKey="id" {columns} rows={customerList} {searchable} {sortable} />
{:else}
    <div class="has-text-centered pt-5">
        <p>
            <span class="icon is-large has-text-grey-light">
                <i class="fas fa-tasks fa-5x" />
            </span>
        </p>
        <h5 class="subtitle is-5 mt-3">{$t('No addresses found')}</h5>
    </div>
{/if}
